import React, { useState } from "react";
import SvgIcon from "../../../../parts/SvgIcon";
import useWindowSize from "../../../../hooks/useWindowSize";

const NutritionHeader = ({
  viewMode,
  handleViewModeChange,
  comesFromBodyComp,
}) => {
  const { innerWidth, innerHeight } = useWindowSize();
  const [ismaximized, setIsMaximized] = useState(false);
  const toggleMaxScreenWidth = () => {
    setIsMaximized(!ismaximized);
    const main = document.querySelector("main");
    main.classList.toggle("maximized");
  };

  return (
    <header>
      <hgroup className="flex gap-1">
        {comesFromBodyComp && (
          <SvgIcon
            classNames="cursor-pointer "
            onClickFn={() => {
              history.back();
            }}
            src={"/img/new-icons/back-button.svg"}
          />
        )}
        <button
          data-button-type={viewMode === "progress" ? "outline" : "secondary"}
          onClick={() => handleViewModeChange("progress")}
        >
          <span>Progress</span>
        </button>
        <button
          data-button-type={viewMode === "plans" ? "outline" : "secondary"}
          onClick={() => handleViewModeChange("plans")}
        >
          <span>Plans</span>
        </button>
      </hgroup>
      {innerWidth > 1600 && (
        <SvgIcon
          src={
            ismaximized
              ? "/img/new-icons/DirectLeft.svg"
              : "/img/new-icons/maximize.svg"
          }
          classNames="opacity-50 hover:opacity-100 cursor-pointer"
          onClickFn={toggleMaxScreenWidth}
        />
      )}
    </header>
  );
};

export default NutritionHeader;
